import { __module as o } from "../../../_virtual/shared.js";
import { s as r } from "./shared-store.js";
(o.exports = function (o, s) {
  return r[o] || (r[o] = void 0 !== s ? s : {});
})("versions", []).push({
  version: "3.31.1",
  mode: "global",
  copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.31.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var s = o.exports;
export { s };